<script>
export default {
	props: ['order', 'checkout'],
}
</script>

<template>
	<GetnetCardContent />
</template>
